import React from 'react';
import { Flex } from '@klarna/mp-ui';
import { Gutter } from 'moet-core';

const HeaderGutter = () => (
  <Flex
    style={{
      borderTopColor: '#E9E9E8',
      borderBottomColor: '#D1D1D0',
      borderStyle: 'solid',
      borderWidth: '1px 0',
    }}
  >
    <Gutter />
  </Flex>
);

export default HeaderGutter;
